import React from 'react';
import _omit from 'lodash/omit';
import { useSelector, useDispatch } from 'react-redux';
import {
  CCreateElement,
  CSidebar,
  CSidebarBrand,
  CSidebarNav,
  CSidebarNavDivider,
  CSidebarNavTitle,
  CSidebarNavDropdown,
  CSidebarNavItem,
  CImg,
} from '@coreui/react';

import { filterNavByPermissions, filterNavByInitiativeSettings } from '../core/helpers/navigation';
import logo from '../assets/images/logo.png';

// sidebar nav config
import navigation from './_nav';
import useGlobalSelectionsContext from '../core/hooks/useGlobalSelectionsContext';

const TheSidebar = () => {
  const dispatch = useDispatch();
  const { sidebarShow } = useSelector((state) => state.base);
  const { permissions } = useSelector((state) => state.auth.auth);
  const { initiativeSettings, adminMode, organizationId, userInitiativeRole } =
    useGlobalSelectionsContext();
  const onSidebarToggle = (val) => {
    dispatch({ type: 'set', sidebarShow: val });
  };

  const navigationItems = React.useMemo(() => {
    if (!organizationId && !adminMode) return [];
    const filterByPermissionsNav = filterNavByPermissions(
      navigation,
      adminMode,
      permissions,
      userInitiativeRole,
    );
    return filterNavByInitiativeSettings(filterByPermissionsNav, initiativeSettings).map((item) =>
      _omit(item, ['adminMode', 'initiativeMode', 'initiativeSettingKey']),
    );
  }, [adminMode, initiativeSettings, organizationId, permissions, userInitiativeRole]);

  return (
    <CSidebar show={sidebarShow} unfoldable onShowChange={(val) => onSidebarToggle(val)}>
      <CSidebarBrand className="d-md-down-none" to="/">
        <div className="logo">
          <CImg height="40px" src={logo} fluid />
          <span>eQual</span>
        </div>
      </CSidebarBrand>
      <CSidebarNav>
        <CCreateElement
          items={navigationItems}
          components={{
            CSidebarNavDivider,
            CSidebarNavDropdown,
            CSidebarNavItem,
            CSidebarNavTitle,
          }}
        />
        <CSidebarNavDivider />
      </CSidebarNav>
    </CSidebar>
  );
};

export default React.memo(TheSidebar);
